import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-local',
  templateUrl: './local.component.html',
  styleUrls: ['./local.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class LocalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
